import { render, staticRenderFns } from "./Cleave.vue?vue&type=template&id=dc55a384&"
import script from "./Cleave.vue?vue&type=script&lang=js&"
export * from "./Cleave.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports